import { stringToArray } from 'src/utils/helpers'

export const formatOrderStatus = (order, t) => {
  if (order?.synch_orders?.includes('error')) {
    return t('sync-error')
  } else if (order?.synch_orders?.includes('ok')) {
    return t('sync-success')
  } else if (order?.synch_orders?.includes('warning')) {
    return t('sync-processed')
  } else {
    return t('sync-disabled')
  }
}

export const getOrderLogBadge = (order) => {
  if (order?.synch_orders?.includes('error')) {
    return 'dm3red'
  } else if (order?.synch_orders?.includes('ok')) {
    return 'success'
  } else if (order?.synch_orders?.includes('warning')) {
    return 'warning'
  } else {
    return 'dark'
  }
}

export const formatOrderLog = (order) => {
  const properties = stringToArray(order?.last_sync?.synch_message)
  return properties?.at(0)?.at(1)?.toString()
}

export const formatOrderLogStatus = (log, order, t) => {
  if (order?.client?.synch_orders && log?.synch_status?.includes('error')) {
    return t('sync-error')
  } else if (order?.client?.synch_orders && log?.synch_status?.includes('ok')) {
    return t('sync-success')
  } else if (order?.client?.synch_orders) {
    return t('sync-processed')
  } else {
    return t('sync-disabled')
  }
}

export const getOrderLogStatusBadge = (log, order) => {
  if (order?.client?.synch_orders && log?.synch_status?.includes('error')) {
    return 'dm3red'
  } else if (order?.client?.synch_orders && log?.synch_status?.includes('ok')) {
    return 'success'
  } else if (order?.client?.synch_orders) {
    return 'warning'
  } else {
    return 'dark'
  }
}

export const getDefaultOrderLogColumns = (t) => [
  { key: 'order_id', label: t('order_id'), _style: { textAlign: 'left' } },
  { key: 'action', label: t('action') },
  { key: 'previous_properties', label: t('previous_properties') },
  { key: 'properties', label: t('properties') },
  { key: 'note', label: t('note') },
  { key: 'created_by_name', label: t('created_by_name') },
  { key: 'synch_status', label: t('synch_status') },
  { key: 'synch_message', label: t('synch_message') },
  { key: 'deleted_by', label: t('deleted_by') },
  { key: 'created_at', label: t('created_at') },
  { key: 'updated_at', label: t('updated_at') },
]
